import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const FRESH_FINANCE_SOCIETY_KEY = "ff_preview_society_id";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Admins select a preview society client-side; the backend reads it from this header
// (society users are always resolved server-side from their own membership).
api.interceptors.request.use((config) => {
  const url = config.url || "";
  if (url.includes("fresh-finance")) {
    const societyId = localStorage.getItem(FRESH_FINANCE_SOCIETY_KEY);
    if (societyId) {
      config.headers = config.headers || {};
      config.headers["X-Fresh-Finance-Society-Id"] = societyId;
    }
  }
  return config;
});

export default api;
